import lazyPlugin from 'vue3-lazy'

export default {
  install: (app) => {
    app.use(lazyPlugin, {
      loading: '/img/loader/image_loader.png',
      error: '/img/icons/android-chrome-192x192.png'
    })
  }
}
